// StoreMenuCardCarousel.js
import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button
} from "reactstrap";

import { Star, Dot } from 'lucide-react';
import VipBadge from "../../components/VipBadge";

import placeholder_image from "assets/images/info/card-placeholder-medium.png";

import "./StoreMenuCardCarousel.css";

const CardCarousel = ({ cards, type, imageMap, navigateToUrl }) => {

  return (
    <div className="store-menu-carousel-container">
      <div className="store-menu-carousel-cards-wrapper">
        <div className="store-menu-carousel-cards-inner">

          {cards.map((card, idx) => {
            return (
              <div
                key={idx}
                className={`store-menu-carousel-card`}
                style={{ 
                  fontSize: "14px",
                  color: "black"
                }}
                onClick={() => {}}
              >
                <div style={{ marginBottom: "5px", width: "100%" }}>
                  <img className='store-menu-carousel-img'
                    src={imageMap[card?.image] || placeholder_image}
                    alt={card.label}
                    style={{ }}
                    onClick={()=>{ 
                      const linkUrl = type === "topics" 
                        ? `/myInfo/storeMenu/topics/${card?._id}` 
                        : `/myInfo/questionSets/${card?._id}`;
                      navigateToUrl(linkUrl); 
                    }}
                  />

                  {type === "questionSets" && card?.pointReward?.amount && (
                    <div className="d-flex align-items-center"
                      style={{
                        position: "absolute",
                        top: "18px",
                        right: "6px"
                      }}
                    >
                      <div className="mb-1 mb-lg-0 me-2 d-flex align-items-center"
                        style={{

                          height: "18px",
                          padding: "0px 3px 1px 3px",
                          cursor: "default",
                          fontSize: "9px",
                          border: "0.5px solid #ffffff",
                          borderRadius: "3px",
                          color: "#eaeaea",
                          backgroundColor: "#00000170"
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          e.currentTarget.blur();
                          return false;
                        }}
                      >
                        <p className="mb-0">{`Tpoint ${card?.pointReward?.amount || 0} 點`}</p>
                      </div>
                    </div>
                  )}
                </div>


                {type === "topics" && (
                  <div style={{ position: "relative", width: "100%"}}>
                    <div className="d-flex flex-column scroll-container-no-scrollbar"
                      style={{ padding: "0px 3px", marginRight: "3px", 
                        overflowX: "scroll", scrollbarWidth: "none", msOverflowStyle: "none" }}
                    >
                      <p className="mb-0" 
                        style={{ fontSize: '15.5px', cursor: 'pointer', whiteSpace: "nowrap" }}
                        onClick={()=>{ navigateToUrl(`/myInfo/storeMenu/topics/${card?._id}`); }}
                      >{card?.label?.length > 10 ? card?.label.slice(0, 10)+'...' : card?.label}</p>
                    </div>

                    {/* Star and VIP level */}
                    <div style={{ marginBottom: '2px', padding: "0px 3px" }}>
                      <Row>
                        <Col className="store-menu-topic-star-col">
                          <div className="d-flex">
                            <p className="mb-0">
                              {
                                card.reviewCount === 0 
                                ? '-'
                                : card.averageRating.toFixed(1)
                              }
                            </p>
                            <Star size={18} fill="#faca82" stroke="none"
                              style={{ margin: '1.8px 2px 0px 2px' }}
                            />
                            <p className="mb-0 text-muted" style={{ fontSize: '13.5px' }}>{`(${card.reviewCount}+)`}</p>
                          </div>

                          <div style={{ margin: '0px 2px 5px 2px' }}>
                            <Dot size={16} />
                          </div>

                          <p style={{ fontSize: '13.5px', color: '#5f6265', margin: '0px 0px 0.5px 0px' }}>
                            {card.followerCount || 0}+{` `}已追蹤
                          </p>

                          {/*
                          <p style={{ fontSize: '13.5px', color: '#ed8f71', fontWeight: 'bold', margin: '0px 0px 3.5px 0px' }}>
                            {`Tpoint ${card?.pointsAward || 0} 點`}
                          </p>
                          */}
                        </Col>
                      </Row>

                    </div>

                    {/*
                    <div className="d-flex align-items-center" style={{ padding: "3px 0px 0px 0px" }}>
                      <div className="mb-lg-0 me-2">
                        <Button color="outline-success" 
                          style={{
                            height: "27px",
                            padding: "0px 5px 1px 5px",
                            cursor: "default",
                            fontSize: "11.5px"
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            e.currentTarget.blur();
                            return false;
                          }}
                        >
                          {card.followerCount || 0}+{` `}已追蹤
                        </Button>
                      </div>
                      <div className="store-menu-follow-action-div">
                        <p className="mb-0">追蹤</p>
                      </div>
                    </div>
                    */}

                  </div>
                )}

                {type === "questionSets" && (
                  <div style={{ position: "relative", width: "100%"}}>
                    <div className="d-flex flex-column scroll-container-no-scrollbar"
                      style={{ padding: "0px 3px", marginRight: "3px", 
                        overflowX: "scroll", scrollbarWidth: "none", msOverflowStyle: "none" }}
                    >
                      <p className="mb-0" 
                        style={{ fontSize: '15.5px', cursor: 'pointer', whiteSpace: "nowrap" }}
                        onClick={()=>{ navigateToUrl(`/myInfo/questionSets/${card?._id}`); }}
                      >{card?.label?.length > 15 ? card?.label.slice(0, 15)+'...' : card?.label}</p>
                    </div>
                    <div>
                      {/* Star and VIP level */}
                      <div className="store-menu-topic-star-col">
                        <div className="d-flex">
                          <p className="mb-0">{card.rating}</p>
                          <Star size={18} fill="#faca82" stroke="none"
                            style={{ margin: '1.8px 2px 0px 2px' }}
                          />
                          {/* A filled star */}
                          <p className="mb-0 text-muted" style={{ fontSize: '13.5px' }}>{`(${card.reviewCount}+)`}</p>
                        </div>
                        <div style={{ margin: '0px 2px 5px 2px' }}>
                          <Dot size={16} /> {/* You can also use a styled div for a smaller solid dot */}
                        </div>

                        <p style={{ fontSize: '13.5px', color: '#5f6265', margin: '0px 0px 0.5px 0px' }}>
                          {card.completionCount || 0}+{` `}已填寫
                        </p>

                        {/*
                        <p style={{ fontSize: '13.5px', color: '#ed8f71', fontWeight: 'bold', margin: '0px 0px 3.5px 0px' }}>
                          {`Tpoint ${card?.pointReward?.amount || 0} 點`}
                        </p>
                        */}
                      </div>

                    </div>

                  </div>
                )}
              

              </div>
            )
          })}

        </div>
      </div>

    </div>
  );
};

export default CardCarousel;
